import moment from "moment";

export const DOCK_ACTIVITY_TYPES = {
  Shipment: "RecDock",
  InventoryRequest: "RelDock",
};

export const dockActivityTypeFor = linkableType => DOCK_ACTIVITY_TYPES[linkableType] || "";

// Diary types that run the same Moveware workflow as the requested one; keep in
// step with Integrations::Moveware::Adapter::ACTIVITY_TYPE_VARIANTS.
const DOCK_ACTIVITY_VARIANTS = {
  RecDock: ["RecDock", "RecDockFFE"],
};

export const matchesDockActivityType = (type, activityType) =>
  (DOCK_ACTIVITY_VARIANTS[activityType] || [activityType]).includes(type);

export const dockActionName = type => {
  if (type === "RelDock") return "release at dock";
  if (type === "RecDock") return "receive at dock";
  return "diary action";
};

export const formatDate = value => {
  const match = String(value || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  return match ? `${match[2]}/${match[3]}/${match[1]}` : value;
};

export const presentDate = value => {
  const text = String(value || "").trim();
  return text ? value : "";
};

export const toIsoDate = value => {
  if (!presentDate(value)) return moment().format("YYYY-MM-DD");
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) return `${match[1]}-${match[2]}-${match[3]}`;
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
};

export const shiftIsoDate = (value, days) => moment(toIsoDate(value)).add(days, "days").format("YYYY-MM-DD");

export const jobIdFor = activity => activity?.jobid || activity?.parentId || activity?.jobId || "";

export const optionFromActivity = activity => {
  if (!activity) return null;
  const jobId = jobIdFor(activity);
  if (!jobId) return null;

  const date = formatDate(activity.date);
  const title = activity.description || activity.type || "Warehouse activity";
  const jobNumber = activity.parentNumber || jobId;
  const contact = activity.contact || "";
  const time = activity.time || activity.timeStartActual || "";

  return {
    value: String(activity.id || `${jobId}-${activity.type || ""}-${activity.date || ""}`),
    jobId: String(jobId),
    jobNumber: String(jobNumber),
    activityId: activity.id,
    type: activity.type,
    description: title,
    contact,
    time,
    date,
    isoDate: toIsoDate(activity.date),
    label: [contact || title, `Job ${jobNumber}`].filter(Boolean).join(" · "),
    activity,
  };
};

export const optionFromRecord = record => {
  if (!record) return null;
  const jobId = record.externalId || record.data?.number || record.displayName;
  if (!jobId) return null;

  return {
    value: `linked-${record.externalId}`,
    jobId: String(record.externalId),
    jobNumber: record.data?.number || record.displayName || record.externalId,
    type: record.data?.type,
    date: formatDate(record.data?.date),
    label: `Job ${record.data?.number || record.externalId}`,
    record,
  };
};
